export default {
  aryCompanyList: [
    {
      label: "Magnum",
      value: "1",
      description: "1 - Magnum"
    },
    {
      label: "Damacai",
      value: "2",
      description: "2 - Damacai"
    },
    {
      label: "Toto",
      value: "3",
      description: "3 - Toto"
    },
    {
      label: "Singapore",
      value: "4",
      description: "4 - Singapore"
    },
    {
      label: "Sabah",
      value: "5",
      description: "5 - Sabah"
    },
    {
      label: "Sarawak",
      value: "6",
      description: "6 - Sarawak"
    },
    {
      label: "Others",
      value: "7",
      disable: true,
      description: "7 - Others"
    }
  ],
  aryPageSizeList: [10, 20, 30, 40, 50, 100],
  appTitle: process.env.VUE_APP_TITLE,
  appVersion: process.env.VUE_APP_VERSION,
  baseUrl: process.env.VUE_APP_BASE_URL,
  userBaseUrl: "/api",
  useConfigUrl: process.env.VUE_APP_STATIC_URL == "true",
  getDomain(url, subdomain) {
    subdomain = subdomain || false;

    url = url.replace(/(http?:\/\/)?(www.)?/i, "");

    if (!subdomain) {
      url = url.split(".");
      url = url.slice(url.length - 2).join(".");
    }

    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }

    return url;
  },
  getBaseUrl() {
    if (this.useConfigUrl) {
      return this.baseUrl;
    }
    var domain = this.getDomain(window.location.hostname, false);
    console.log(domain, window.location.hostname);
    if (domain != "localhost" && domain != "127.0.0.1") {
      return "http://" + domain + ":3333";
      // return "https://api." + domain;
    } else {
      return this.baseUrl;
    }
  },
  loginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/userlogin";
  },
  functionListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getfunctionlist";
  },
  addFunctionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addfunction";
  },
  editFunctionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/editfunctioninfo";
  },
  deleteFunctionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deletefunction";
  },
  pageListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpagelist";
  },
  addPageUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addpage";
  },
  editPageUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/editpageinfo";
  },
  deletePageUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deletepage";
  },
  roleListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getrolelist";
  },
  addRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addrole";
  },
  editRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/editroleinfo";
  },
  deleteRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deleterole";
  },
  userListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getuserlist";
  },
  editUserStatusUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/userstatusupdate";
  },
  addUserUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/createuser";
  },
  editUserUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/updateuser";
  },
  resetPwdUserUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/userpasswordreset";
  },
  getUserRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getuserrole";
  },
  addUserRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/useraddroles";
  },
  pageFunctionListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpagefunctionlist";
  },
  pageRoleListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpagerolelist";
  },
  editPageFunctionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/upsertpagefunction";
  },
  editPageRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/upsertpagerole";
  },
  userchangepassword_Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/userchangepassword";
  },
  defaultNumberList_Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/rednumdefaultalllist";
  },
  defaultNumberAddAndEdit_Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/rednumdefaultupsert";
  },
  defaultNumberAdd_Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/rednumdefaultallinsert";
  },
  defaultNumberEdit_Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/rednumdefaultallupdate";
  },
  defaultNumberDelete_Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/rednumdefaultalldelete";
  },
  matchNumberLookupByDate_Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/rednummatchlookupbydate";
  },
  matchNumberList_Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/rednumalllist";
  },
  matchNumberList_Company_Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/rednumlist";
  },
  matchNumberAdd_Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/rednumallinsert";
  },
  matchNumberEdit_Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/rednumallupdate";
  },
  matchNumberDelete_Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/rednumalldelete";
  },
  betList_Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/betlistexcel";
  },
  betList_Company_Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/betlistexport";
  },
  betListExport_Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/betlistexcelxlsx";
  }
};
